import { Directive, OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject } from 'rxjs';

@Directive()
export class FormlyFieldBaseComponent extends FieldType implements OnDestroy {
  protected destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get key(): string {
    return this.field.key as string;
  }

  get valid(): boolean {
    return (this.formControl.dirty || this.formControl.touched) && !this.showError && this.useValidation;
  }

  get invalid(): boolean {
    return this.showError && this.useValidation;
  }

  get useValidation(): boolean {
    return !this.props.readonly && !this.props.required;
  }

  get hasValidation(): boolean {
    return (
      this.field.validators.validation.length > 0 ||
      Object.keys(this.field.validators).filter((x) => x !== 'validation').length > 0
    );
  }
}
